module.exports = __webpack_public_path__ + "img/mbh3.080dd6ab.jpg";